export const regex = {
    ONLY_POSITIVE_INTEGERS: /^\d+$/,
    ONLY_NUMBERS_WITH_THREE_DECIMALS: /^\d{0,99}(.\d{1,3})?$/,
    ONLY_NUMBERS_AND_LETTERS: /^[a-zA-Z0-9]*$/,
    EQUALS_CONTAINER_PLATE: /[a-zA-Z]{4}[\d]{7}$/,
    NOT_EQUALS_CONTAINER_PLATE: /^(?![a-zA-Z]{4}[\d]{7}$)/,
};
